import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSeedling } from '@fortawesome/free-solid-svg-icons/faSeedling';
import type { IconProps } from '../../types';

export function SeedlingIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'Seedling',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faSeedling}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
